



































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { AdminDobNameChangeUsers } from "@/admin/route-names";
import { AdminDobNameChangeTitle, AdminDobNameChangeSubtitle } from "@/admin/constants";
import { UserDobNameModel } from "@/admin/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserSearchStore } from "@/admin/store/userSearch";
import { useUtilityStore } from "@/admin/store/utility";

@Component
export default class AdminDobNameChange extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  userSearchStore = useUserSearchStore();
  utilityStore = useUtilityStore();

  title = AdminDobNameChangeTitle;
  subtitle = AdminDobNameChangeSubtitle;
  updateFormInSubmit = false;
  formModel: UserDobNameModel = {
    userId: 0,
    firstName: "",
    lastName: "",
    dateOfBirth: ""
  };

  @Prop()
  userId: number;

  created () {
    this.fetchUser();
  }

  @Watch("userId")
  fetchUser () {
    this.resetForm();
    this.userSearchStore.loadUser(this.userId)
      .then(user => {
        this.formModel = {
          userId: user.userId,
          firstName: user.firstName,
          lastName: user.lastName,
          dateOfBirth: user.dateOfBirth
        };
      });
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (this.updateFormInSubmit || !isValid) {
          return;
        }

        this.updateFormInSubmit = true;
        this.doUpdateDobName();
      });
  }

  onResetForm () {
    this.$router.push({ name: AdminDobNameChangeUsers });
    this.userSearchStore.reset();
  }

  doUpdateDobName () {
    this.utilityStore.saveAdminDobNameChange(this.formModel)
      .then(() => {
        this.$router.push({ name: AdminDobNameChangeUsers });
        this.notifierStore.setSuccess(`${this.formModel.firstName} ${this.formModel.lastName}'s information has been saved.`);
        this.userSearchStore.reset();
      })
      .finally(() => this.updateFormInSubmit = false);
  }

  resetForm () {
    this.formModel = {
      userId: 0,
      firstName: "",
      lastName: "",
      dateOfBirth: ""
    };
  }
}
